module.exports = __webpack_public_path__ + "static/media/0004.d6ed3d52.JPG";